/**
 * Portuguese (pt-BR) i18n labels for emoji-mart v3 Picker
 * and high-coverage bilingual (PT <-> EN) search dictionary.
 */

export const emojiI18n = {
  search: "Pesquisar emoji",
  clear: "Limpar",
  notfound: "Nenhum emoji encontrado",
  skintext: "Escolha o tom de pele padrão",
  categories: {
    search: "Resultados da pesquisa",
    recent: "Recentes",
    smileys: "Smileys e Pessoas",
    people: "Pessoas e Corpo",
    nature: "Animais e Natureza",
    foods: "Comida e Bebida",
    activity: "Atividades",
    places: "Viagens e Lugares",
    objects: "Objetos",
    symbols: "Símbolos",
    flags: "Bandeiras",
    custom: "Personalizado",
  },
  categorieslabels: {
    search: "Resultados",
    recent: "Mais usados",
    smileys: "Smileys e pessoas",
    people: "Pessoas",
    nature: "Animais e natureza",
    foods: "Comida e bebida",
    activity: "Atividades",
    places: "Viagens e lugares",
    objects: "Objetos",
    symbols: "Símbolos",
    flags: "Bandeiras",
    custom: "Personalizados",
  },
};

export const normalizeText = (str) =>
  (str || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .trim();

/**
 * Portuguese search terms mapped to English search terms/emoji IDs
 */
export const ptToEnDictionary = {
  // ── Curtidas, Reações e Gestos ──────────────────────────────────────────
  "joinha": "thumbsup +1 like",
  "curtida": "thumbsup +1 like heart",
  "curtir": "thumbsup +1 like heart",
  "like": "thumbsup +1 like",
  "positivo": "thumbsup +1 yes agree",
  "polegar": "thumbsup thumbsdown",
  "aprovado": "thumbsup white_check_mark",
  "deslike": "thumbsdown -1",
  "descurtir": "thumbsdown -1",
  "negativo": "thumbsdown -1 no",
  "reprovado": "thumbsdown x",
  "palmas": "clap clapping applause",
  "palma": "clap clapping applause",
  "aplauso": "clap clapping applause",
  "aplausos": "clap clapping applause",
  "bater palmas": "clap clapping",
  "oracao": "pray folded_hands please thanks",
  "oração": "pray folded_hands please thanks",
  "rezar": "pray folded_hands",
  "rezando": "pray folded_hands",
  "amem": "pray folded_hands",
  "amém": "pray folded_hands",
  "por favor": "pray folded_hands",
  "gratidao": "pray folded_hands sparkles",
  "gratidão": "pray folded_hands sparkles",
  "agradecido": "pray folded_hands",
  "coracao": "heart red_heart love",
  "coração": "heart red_heart love",
  "amor": "heart red_heart love heart_eyes",
  "amando": "heart red_heart love heart_eyes",
  "te amo": "heart red_heart love",
  "paixao": "heart red_heart love heart_eyes",
  "paixão": "heart red_heart love heart_eyes",
  "carinho": "heart red_heart smiling_face_with_three_hearts",
  "coracao partido": "broken_heart",
  "coração partido": "broken_heart",
  "fogo": "fire flame lit hot",
  "foginho": "fire flame",
  "chama": "fire flame",
  "flama": "fire flame",
  "quente": "fire hot",
  "forca": "muscle strong flexed",
  "força": "muscle strong flexed",
  "musculo": "muscle strong flexed",
  "músculo": "muscle strong flexed",
  "forte": "muscle strong flexed",
  "academia": "muscle strong weight_lifter",
  "foco": "muscle target",
  "paz": "peace victory v",
  "vitoria": "victory peace v",
  "vitória": "victory peace v",
  "valeu": "ok_hand thumbsup wave",
  "ok": "ok_hand ok",
  "beleza": "ok_hand thumbsup",
  "combinado": "ok_hand handshake check",
  "certo": "ok_hand white_check_mark check",
  "joia": "thumbsup ok_hand",
  "tchau": "wave waving bye",
  "adeus": "wave waving bye",
  "ola": "wave waving hi hello",
  "olá": "wave waving hi hello",
  "oi": "wave waving hi hello",
  "aceno": "wave waving",
  "acenando": "wave waving",
  "mao": "hand waving raised_hand",
  "mão": "hand waving raised_hand",
  "dedo": "point_up point_down point_left point_right finger",
  "apontar": "point_up point_down point_left point_right",
  "soco": "punch fist facepunch",
  "punho": "fist punch",
  "bate aqui": "handshake pray fist",
  "toque": "fist handshake",
  "aperto de mao": "handshake",
  "aperto de mão": "handshake",
  "parceria": "handshake",
  "abraco": "hugging hug",
  "abraço": "hugging hug",
  "olho": "eyes eye",
  "olhos": "eyes eye",
  "espiando": "eyes",
  "vendo": "eyes",

  // ── Emoções e Expressões (Smileys) ───────────────────────────────────────
  "feliz": "happy smile grinning grin joy",
  "alegre": "happy joy smile",
  "sorrindo": "smile grinning grin slightly_smiling_face",
  "sorriso": "smile grinning grin",
  "contente": "happy smile",
  "radiante": "grin smiling_face_with_three_hearts star_struck",
  "rindo": "laughing joy rofl smile",
  "risada": "laughing joy rofl smile",
  "gargalhada": "rofl laughing joy",
  "kkk": "joy rofl laughing",
  "haha": "joy rofl laughing",
  "rs": "smile grinning",
  "engracado": "joy rofl laughing",
  "engraçado": "joy rofl laughing",
  "triste": "sad crying sob disappointed slightly_frowning_face",
  "chateado": "sad disappointed slightly_frowning_face",
  "depre": "sad crying pensive",
  "choro": "cry sob crying tears",
  "chorando": "cry sob crying tears",
  "lagrimas": "cry sob tears",
  "lágrimas": "cry sob tears",
  "suor": "sweat_smile sweat cold_sweat",
  "alivio": "relieved sweat_smile",
  "alívio": "relieved sweat_smile",
  "ufa": "relieved sweat_smile",
  "piscadela": "wink",
  "piscando": "wink",
  "piscar": "wink",
  "beijo": "kiss kissing kissing_heart kissing_closed_eyes",
  "beijinho": "kissing_heart kiss",
  "apaixonado": "heart_eyes smiling_face_with_three_hearts love",
  "apaixonada": "heart_eyes smiling_face_with_three_hearts love",
  "amoroso": "heart_eyes smiling_face_with_three_hearts",
  "baba": "drooling_face",
  "babando": "drooling_face",
  "lingua": "stuck_out_tongue stuck_out_tongue_winking_eye yum zany_face",
  "língua": "stuck_out_tongue stuck_out_tongue_winking_eye yum zany_face",
  "careta": "zany_face grimacing stuck_out_tongue",
  "zoeira": "zany_face rofl laughing",
  "oculos": "sunglasses cool nerd_face",
  "óculos": "sunglasses cool nerd_face",
  "oculos escuros": "sunglasses cool",
  "óculos escuros": "sunglasses cool",
  "descolado": "sunglasses cool",
  "estiloso": "sunglasses",
  "nerd": "nerd_face",
  "cdf": "nerd_face",
  "inteligente": "nerd_face bulb",
  "pensando": "thinking hmm",
  "pensativo": "thinking hmm",
  "duvida": "thinking question",
  "dúvida": "thinking question",
  "silencio": "shushing_face zipper_mouth_face",
  "silêncio": "shushing_face zipper_mouth_face",
  "segredo": "shushing_face zipper_mouth_face",
  "quieto": "shushing_face",
  "calado": "zipper_mouth_face shushing_face",
  "dormindo": "sleeping zzz sleepy",
  "sono": "sleeping zzz sleepy yawning_face",
  "dormir": "sleeping bed zzz",
  "cansado": "tired_face weary sleepy",
  "bocejo": "yawning_face",
  "surpreso": "astonished open_mouth scream flushed",
  "surpresa": "astonished open_mouth scream flushed tada",
  "chocado": "astonished scream shocked flushed",
  "chocada": "astonished scream shocked flushed",
  "uau": "star_struck astonished open_mouth",
  "medo": "fearful scream cold_sweat",
  "assustado": "fearful scream cold_sweat",
  "panico": "scream fearful",
  "pânico": "scream fearful",
  "socorro": "scream fearful",
  "raiva": "angry rage furious",
  "irritado": "angry rage",
  "bravo": "angry rage",
  "furioso": "rage angry",
  "nervoso": "angry grimacing cold_sweat",
  "explodindo": "exploding_head",
  "mente explodindo": "exploding_head",
  "doente": "sick mask face_with_thermometer nauseated",
  "febre": "face_with_thermometer",
  "gripe": "sneezing_face face_with_thermometer",
  "mascara": "mask",
  "máscara": "mask",
  "enjoado": "nauseated face_vomiting",
  "vomitando": "face_vomiting",
  "palhaco": "clown_face",
  "palhaço": "clown_face",
  "festa": "partying_face tada confetti_ball celebration",
  "comemoracao": "partying_face tada celebration",
  "comemoração": "partying_face tada celebration",
  "aniversario": "birthday cake partying_face tada",
  "aniversário": "birthday cake partying_face tada",
  "parabens": "tada confetti_ball partying_face congratulations",
  "parabéns": "tada confetti_ball partying_face congratulations",
  "balao": "balloon",
  "balão": "balloon",
  "dinheiro": "moneybag money_mouth_face dollar euro",
  "rico": "moneybag dollar money_mouth_face",
  "grana": "moneybag dollar",
  "dolar": "dollar moneybag",
  "dólar": "dollar moneybag",
  "coco": "poop hankey",
  "cocô": "poop hankey",
  "merda": "poop hankey",
  "bosta": "poop hankey",
  "anjo": "innocent angel",
  "santinho": "innocent angel",
  "diabo": "smiling_imp imp devil",
  "diabinho": "smiling_imp imp devil",
  "demonio": "smiling_imp imp devil",
  "demônio": "smiling_imp imp devil",
  "caveira": "skull skull_and_crossbones",
  "morte": "skull coffin skull_and_crossbones",
  "morto": "skull dizzy_face",
  "fantasma": "ghost",
  "halloween": "jack_o_lantern ghost pumpkin",
  "abobora": "jack_o_lantern pumpkin",
  "abóbora": "jack_o_lantern pumpkin",
  "alien": "alien space_invader",
  "alienigena": "alien space_invader",
  "alienígena": "alien space_invader",
  "robo": "robot",
  "robô": "robot",
  "bot": "robot",
  "macaco": "monkey see_no_evil hear_no_evil speak_no_evil",
  "mico": "monkey",

  // ── Comidas e Bebidas ────────────────────────────────────────────────────
  "cafe": "coffee tea",
  "café": "coffee tea",
  "cha": "tea coffee",
  "chá": "tea coffee",
  "copo": "cup tumbler_glass",
  "caneca": "coffee beer",
  "cerveja": "beer beers clinking_glasses",
  "chopp": "beer beers",
  "brinde": "clinking_glasses beer champagne",
  "saude": "clinking_glasses beer",
  "saúde": "clinking_glasses beer",
  "vinho": "wine_glass champagne",
  "taca": "wine_glass champagne",
  "taça": "wine_glass champagne",
  "champanhe": "champagne clinking_glasses",
  "agua": "water ocean droplet",
  "água": "water ocean droplet",
  "pizza": "pizza",
  "hamburguer": "hamburger burger",
  "hambúrguer": "hamburger burger",
  "lanche": "hamburger sandwich",
  "batata": "fries potato",
  "batata frita": "fries",
  "carne": "meat_on_bone cut_of_meat steak",
  "churrasco": "meat_on_bone cut_of_meat",
  "doce": "candy chocolate_bar lollipop",
  "chocolate": "chocolate_bar",
  "bolo": "cake birthday",
  "torta": "pie cake",
  "sorvete": "ice_cream icecream shaved_ice",
  "pipoca": "popcorn",
  "queijo": "cheese",
  "pao": "bread baguette_bread",
  "pão": "bread baguette_bread",
  "arroz": "rice",
  "maca": "apple",
  "maçã": "apple",
  "banana": "banana",
  "uva": "grapes",
  "laranja": "orange tangerine",
  "morango": "strawberry",
  "abacaxi": "pineapple",
  "melancia": "watermelon",
  "limao": "lemon",
  "limão": "lemon",

  // ── Natureza, Tempo e Animais ───────────────────────────────────────────
  "sol": "sunny sun beach",
  "calor": "sun hot_face fire",
  "verao": "sun beach watermelon",
  "verão": "sun beach watermelon",
  "praia": "beach_with_umbrella ocean island",
  "mar": "ocean wave water",
  "rio": "ocean water",
  "lua": "moon crescent_moon full_moon",
  "noite": "moon night_with_stars star",
  "estrela": "star stars glowing_star sparkle",
  "estrelas": "stars sparkle",
  "ceu": "cloud sun sky",
  "céu": "cloud sun sky",
  "chuva": "rain cloud_with_rain umbrella",
  "chuvoso": "rain cloud_with_rain",
  "nuvem": "cloud cloud_with_rain",
  "guarda chuva": "umbrella beach_with_umbrella",
  "guarda-chuva": "umbrella beach_with_umbrella",
  "tempestade": "thunder_cloud_and_rain lightning",
  "raio": "zap lightning thunder",
  "trovao": "zap lightning",
  "trovão": "zap lightning",
  "frio": "cold_face snowflake snowman",
  "neve": "snowflake snowman",
  "flor": "flower rose blossom sunflower",
  "flores": "blossom flower rose",
  "rosa": "rose flower",
  "girassol": "sunflower",
  "arvore": "tree evergreen_tree deciduous_tree",
  "árvore": "tree evergreen_tree deciduous_tree",
  "folha": "leaf leaves fallen_leaf",
  "arco iris": "rainbow",
  "arco-íris": "rainbow",
  "gato": "cat cat2 kitten",
  "gatinho": "cat kitten",
  "cachorro": "dog dog2 puppy",
  "cao": "dog puppy",
  "cão": "dog puppy",
  "cachorrinho": "dog puppy",
  "passaro": "bird eagle pigeon",
  "pássaro": "bird eagle pigeon",
  "peixe": "fish tropical_fish",
  "borboleta": "butterfly",
  "abelha": "bee",
  "cobra": "snake",
  "leao": "lion",
  "leão": "lion",
  "tigre": "tiger tiger2",
  "urso": "bear",
  "coelho": "rabbit rabbit2",
  "rato": "mouse mouse2 rat",
  "cavalo": "horse",
  "porco": "pig pig2",
  "vaca": "cow cow2",
  "galinha": "chicken rooster",
  "elefante": "elephant",
  "girafa": "giraffe",
  "golfinho": "dolphin",
  "tubarao": "shark",
  "tubarão": "shark",
  "tartaruga": "turtle",
  "panda": "panda_face",

  // ── Objetos, Tecnologia e Transporte ────────────────────────────────────
  "computador": "computer laptop desktop_computer pc",
  "notebook": "laptop computer",
  "laptop": "laptop computer",
  "pc": "desktop_computer computer",
  "tela": "desktop_computer tv",
  "celular": "iphone mobile_phone phone",
  "telefone": "telephone telephone_receiver phone",
  "ligacao": "telephone telephone_receiver",
  "ligação": "telephone telephone_receiver",
  "relogio": "clock watch alarm_clock hourglass",
  "relógio": "clock watch alarm_clock hourglass",
  "tempo": "clock watch hourglass hourglass_flowing_sand",
  "hora": "clock watch",
  "alarme": "alarm_clock clock",
  "despertador": "alarm_clock",
  "lampada": "bulb light idea",
  "lâmpada": "bulb light idea",
  "ideia": "bulb light star",
  "luz": "bulb light star",
  "brilho": "sparkles sparkle star",
  "musica": "musical_note notes musical_score headphones",
  "música": "musical_note notes musical_score headphones",
  "som": "loud_sound musical_note speaker",
  "fone": "headphones",
  "headphone": "headphones",
  "casa": "house home",
  "carro": "car automobile taxi",
  "automovel": "car automobile",
  "automóvel": "car automobile",
  "taxi": "taxi car",
  "táxi": "taxi car",
  "onibus": "bus",
  "ônibus": "bus",
  "moto": "motorcycle scooter",
  "motocicleta": "motorcycle",
  "bicicleta": "bike bicycle",
  "bike": "bike bicycle",
  "aviao": "airplane plane flight",
  "avião": "airplane plane flight",
  "viagem": "airplane tropical_island luggage",
  "viajar": "airplane luggage island",
  "aeroporto": "airplane airport",
  "barco": "ship boat sailing_boat",
  "navio": "ship ferry cruise",
  "trem": "train bullettrain_front",
  "foguete": "rocket",
  "chave": "key",
  "cadeado": "lock locked",
  "livro": "book books notebook",
  "presente": "gift present",
  "trofeu": "trophy medal",
  "troféu": "trophy medal",
  "medalha": "medal trophy",
  "futebol": "soccer football",
  "bola": "soccer basketball baseball",
  "jogo": "video_game joystick soccer",
  "game": "video_game joystick",
  "mensagem": "email envelope speech_balloon",
  "carta": "envelope email",
  "email": "envelope email",
  "lixo": "wastebasket trash",
  "tesoura": "scissors",
  "caneta": "pen writing_hand",
  "lapis": "pencil memo",
  "lápis": "pencil memo",

  // ── Símbolos, Status e Bandeiras ─────────────────────────────────────────
  "check": "white_check_mark heavy_check_mark check",
  "certo": "white_check_mark check",
  "correto": "white_check_mark check",
  "verificado": "white_check_mark",
  "confirmado": "white_check_mark check",
  "sucesso": "white_check_mark tada trophy",
  "errado": "x negative_squared_cross_mark no_entry",
  "x": "x negative_squared_cross_mark",
  "cancelado": "x no_entry_sign",
  "fechar": "x",
  "proibido": "no_entry no_entry_sign prohibited",
  "alerta": "warning exclamation",
  "aviso": "warning exclamation",
  "atencao": "warning exclamation",
  "atenção": "warning exclamation",
  "perigo": "warning danger",
  "cuidado": "warning",
  "pergunta": "question",
  "interrogacao": "question",
  "interrogação": "question",
  "exclamacao": "exclamation",
  "exclamação": "exclamation",
  "bandeira": "flag flag-br",
  "brasil": "flag-br",
  "brazil": "flag-br",
  "verde e amarelo": "flag-br",
  "portugal": "flag-pt",
  "estados unidos": "flag-us",
  "eua": "flag-us",
  "argentina": "flag-ar",
  "espanha": "flag-es",
};

// Normalized lookup map for fast normalized and prefix lookups
const normalizedLookup = {};
for (const [key, value] of Object.entries(ptToEnDictionary)) {
  const norm = normalizeText(key);
  if (!normalizedLookup[norm]) {
    normalizedLookup[norm] = value;
  } else {
    normalizedLookup[norm] += ` ${value}`;
  }
}

/**
 * Given a user search term (in PT or EN), return all corresponding English terms.
 * Handles exact matches, accent-less matches, and prefix typing ("sorr" -> smile).
 */
export function getEnglishSearchTerms(userQuery) {
  if (!userQuery) return [];
  const normalizedQuery = normalizeText(userQuery);
  if (!normalizedQuery) return [];

  const terms = new Set();

  for (const [ptKey, enValue] of Object.entries(normalizedLookup)) {
    // Exact or prefix match (min 2 chars for prefix to avoid excessive noise)
    if (
      ptKey === normalizedQuery ||
      (normalizedQuery.length >= 2 && ptKey.startsWith(normalizedQuery))
    ) {
      enValue.split(/\s+/).forEach((t) => {
        if (t) terms.add(t);
      });
    }
  }

  // Also check individual words if multi-word query
  const words = normalizedQuery.split(/\s+/);
  if (words.length > 1) {
    for (const w of words) {
      if (w.length >= 2) {
        for (const [ptKey, enValue] of Object.entries(normalizedLookup)) {
          if (ptKey === w || ptKey.startsWith(w)) {
            enValue.split(/\s+/).forEach((t) => {
              if (t) terms.add(t);
            });
          }
        }
      }
    }
  }

  return [...terms];
}

/**
 * Configure emoji-mart emojiIndex to seamlessly support Portuguese + English search.
 */
export function setupEmojiMartSearch(emojiIndex) {
  if (!emojiIndex || emojiIndex._hasPtSearchPatch) return;
  emojiIndex._hasPtSearchPatch = true;

  const originalSearch = emojiIndex.search.bind(emojiIndex);

  emojiIndex.search = (query, options) => {
    if (!query || typeof query !== "string") {
      return originalSearch(query, options);
    }

    // 1. First, search directly (matches native English terms, emoji names, colons)
    const directResults = originalSearch(query, options) || [];

    // 2. Resolve Portuguese translations / prefix matches
    const englishTerms = getEnglishSearchTerms(query);
    if (!englishTerms || englishTerms.length === 0) {
      return directResults;
    }

    // 3. Search each resolved English term and merge unique results
    const seen = new Set(directResults.map((em) => em.id));
    const merged = [...directResults];

    for (const term of englishTerms) {
      const termResults = originalSearch(term, options) || [];
      for (const em of termResults) {
        if (!seen.has(em.id)) {
          seen.add(em.id);
          merged.push(em);
        }
      }
    }

    return merged;
  };
}
